import { Fieldset } from "primereact/fieldset";
import { DateTimeDisplay } from "@components/datetime-display";
import { useTranslation } from "@i18n/hooks";
import {
	adminCloseOrderClass,
	adminEmailActionClass,
	metaRowClass,
	whenClass,
} from "./order-history-event-display.styles";
import {
	type AdminActionTone,
	type OrderHistoryEventDisplayProps,
} from "./order-history-event-display.types";

const adminActionToneClass: Record<AdminActionTone, string> = {
	adminEmailAction: adminEmailActionClass,
	adminCloseOrder: adminCloseOrderClass,
};

export const OrderHistoryEventDisplay = ({
	event,
	when,
	adminActionTone,
	children,
}: OrderHistoryEventDisplayProps) => {
	const { t } = useTranslation("common");
	const hasChildren = children !== undefined;
	const eventName = t(`historyEventType.${event}`);

	return (
		<Fieldset
			legend={hasChildren ? eventName : undefined}
			className={adminActionTone && adminActionToneClass[adminActionTone]}
		>
			<div className={metaRowClass}>
				{!hasChildren && <span>{eventName}</span>}
				<span className={whenClass}>
					<DateTimeDisplay value={when} hideTimezone />
				</span>
			</div>
			{children}
		</Fieldset>
	);
};
